import React, { useState, useLayoutEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import logo from '../Images/supplydrive_logo_wit.png';
import RenderOnRole from "../Utilities/RenderOnRole";
import Logout from "./Logout";
import LanguageSwitcher from "./LanguageSwitcher";
import ThemeToggle from "./ThemeToggle";
import { createPortal } from "react-dom";
import "../css/header.css"

function Header() {
    let history = useHistory();
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    useLayoutEffect(() => {
        if (open && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom,
                left: rect.left,
            });
        }
    }, [open]);

    return (
        <header className="app-header">
            <div className="app-header__left">
                <img src={logo} width="160" height="48" className="app-header__logo" alt="Supplydrive" />
            </div>
            {/* <h1 className="font-bold inline text-xl ml-2 mr-2 h-full">
                Supplydrive Portaal
            </h1> */}
            <nav className="app-header__nav">
                <RenderOnRole roles={["Account_Beheerder", "Administrator", "SD_Medewerker"]}>
                    <button className="app-nav-button" onClick={() => { history.push({ pathname: "/AccountBeheer" }) }}>
                        {t('header.accountManagement')}
                    </button>
                </RenderOnRole>
                <RenderOnRole roles={["Klant"]}>
                    <button className="app-nav-button" onClick={() => { history.push({ pathname: "/DashboardKlant" }) }}>
                        {t('header.dashboard')}
                    </button>
                </RenderOnRole>
                <RenderOnRole roles={["SD_Medewerker", "Administrator"]} className="h-full">
                    <button className="app-nav-button" onClick={() => { history.push({ pathname: "/Klanten" }) }}>
                        {t('header.customers')}
                    </button>

                    <button className="app-nav-button app-nav-button--divider" onClick={() => { history.push({ pathname: "/DashboardKlant" }) }}>
                        {t('header.dashboard')}
                    </button>

                    <button className="app-nav-button app-nav-button--divider" onClick={() => { history.push({ pathname: "/MessageManagement" }) }}>
                        {t('header.messageManagement')}
                    </button>

                    <button ref={buttonRef} className="app-nav-button app-nav-button--divider" onClick={() => setOpen(true)} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
                        Tools
                        {open ?
                            createPortal(
                                <div
                                    className="fixed bg-white dark:bg-black shadow-lg border rounded-md w-48 z-[9999]"
                                    style={{
                                        top: position.top,
                                        left: position.left,
                                    }}
                                    onMouseEnter={() => setOpen(true)}
                                    onMouseLeave={() => setOpen(false)}
                                >
                                    <button className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800" onClick={() => { history.push({ pathname: "/Base64Converter" }) }}>
                                        Base64 Converter
                                    </button>
                                    <button className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800" onClick={() => { history.push({ pathname: "/PdfParser" }) }}>
                                        Pdf Parser
                                    </button>
                                    <button className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800" onClick={() => { history.push({ pathname: "/PathTester" }) }}>
                                        Path Tester
                                    </button>
                                </div>,
                                document.body
                            )
                            :
                            ""
                        }
                    </button>

                    <button className="app-nav-button app-nav-button--divider" onClick={() => { history.push({ pathname: "/Validator" }) }}>
                        Validator
                    </button>

                    <button className="app-nav-button app-nav-button--divider" onClick={() => { history.push({ pathname: "/PromptOpt" }) }}>
                        {t('header.promptOpt')}
                    </button>

                    <RenderOnRole roles={["Administrator"]}>
                        <button className="app-nav-button app-nav-button--divider" onClick={() => { history.push({ pathname: "/Betalingen" }) }}>
                            {t('header.payments')}
                        </button>
                    </RenderOnRole>
                </RenderOnRole>
            </nav>
            <div className="app-header__right">
                <ThemeToggle />
                <LanguageSwitcher />
                <Logout className="app-nav-button app-nav-button--divider app-logout-button" />
            </div>

        </header>
    )
}
export default Header